import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  Library,
  LayoutDashboard,
  Settings,
} from "lucide-react";

const MobileBottomBar = ({ onError, theme = 'light' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    { icon: <Library className="h-5 w-5" />, label: 'Library', path: '/library' },
    { icon: <LayoutDashboard className="h-5 w-5" />, label: 'Stats', path: '/stats' },
    { icon: <Settings className="h-5 w-5" />, label: 'Settings', path: '/settings' }
  ];

  const handleNavigation = (e, path, state) => {
    e.preventDefault();
    navigate(path, { state });
  };

  return (
    <div className={cn(
      "md:hidden fixed bottom-0 left-0 right-0 backdrop-blur-lg border-t z-[9999]",
      theme === 'light' 
        ? "bg-white/80 border-gray-200/50"
        : "bg-gray-800/80 border-gray-700/50"
    )}>
      <div className="flex justify-around items-center h-16 px-4">
        {navigationItems.map((item) => (
          <button
            key={item.path}
            onClick={(e) => handleNavigation(e, item.path, item.state)}
            className={cn(
              "flex flex-col items-center justify-center space-y-1 px-3 py-2 rounded-lg transition-colors",
              (location.pathname === item.path && (!item.state || location.state?.batchMode === item.state?.batchMode))
                ? theme === 'light' 
                  ? "text-indigo-600" 
                  : "text-indigo-400"
                : theme === 'light'
                  ? "text-gray-600 hover:text-gray-900"
                  : "text-gray-400 hover:text-gray-200"
            )}
          >
            {item.icon}
            <span className="text-xs">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileBottomBar; 